import React from 'react';
import { DynamicIcon } from '../icons/DynamicIcon';

interface TabDetalhesEventoProps {
  eventoData: {
    nomeEvento: string;
    tipoEvento: string;
    dataEvento: string;
    horarioInicio: string;
    horarioTermino: string;
    localEvento: string;
    numeroConvidados: number;
  };
  setEventoData: React.Dispatch<React.SetStateAction<any>>;
}

const TabDetalhesEvento: React.FC<TabDetalhesEventoProps> = ({ eventoData, setEventoData }) => {
  const tiposEvento = [
    'aniversario', 'casamento', 'formatura', 'corporativo', 
    'festival', 'happyhour', 'confraternizacao', 'outros'
  ];

  const calcularDuracao = () => {
    if (eventoData.horarioInicio && eventoData.horarioTermino) {
      const [horaInicio, minInicio] = eventoData.horarioInicio.split(':').map(Number);
      const [horaFim, minFim] = eventoData.horarioTermino.split(':').map(Number);
      
      // Converter para minutos para facilitar o cálculo
      let inicioMinutos = horaInicio * 60 + minInicio;
      let fimMinutos = horaFim * 60 + minFim;
      
      // Se o horário de término for menor que o de início, assumimos que é no dia seguinte
      if (fimMinutos < inicioMinutos) {
        fimMinutos += 24 * 60; // Adiciona 24 horas em minutos
      }
      
      const duracaoMinutos = fimMinutos - inicioMinutos;
      const horas = Math.floor(duracaoMinutos / 60);
      const minutos = duracaoMinutos % 60;
      
      return `${horas}h${minutos > 0 ? ` ${minutos}min` : ''}`;
    }
    return '';
  };

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-xl font-bold mb-6 flex items-center">
        <DynamicIcon name="calendar" size={24} className="mr-2 text-blue-600" />
        Detalhes do Evento
      </h2>
      
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1 text-gray-700">Nome do Evento</label>
          <input
            type="text"
            className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            value={eventoData.nomeEvento}
            onChange={(e) => setEventoData({...eventoData, nomeEvento: e.target.value})}
            placeholder="Ex: Aniversário de 30 anos"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1 text-gray-700">Tipo de Evento</label>
          <select
            className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            value={eventoData.tipoEvento}
            onChange={(e) => setEventoData({...eventoData, tipoEvento: e.target.value})}
          >
            {tiposEvento.map(tipo => (
              <option key={tipo} value={tipo}>
                {tipo.charAt(0).toUpperCase() + tipo.slice(1)}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium mb-1 text-gray-700">Data do Evento</label>
          <input
            type="date"
            className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            value={eventoData.dataEvento}
            onChange={(e) => setEventoData({...eventoData, dataEvento: e.target.value})}
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1 text-gray-700">Número de Convidados</label>
          <input
            type="number"
            className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            value={eventoData.numeroConvidados}
            onChange={(e) => setEventoData({...eventoData, numeroConvidados: parseInt(e.target.value) || 0})}
            min="1"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1 text-gray-700">Horário de Início</label>
          <input
            type="time"
            className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            value={eventoData.horarioInicio}
            onChange={(e) => setEventoData({...eventoData, horarioInicio: e.target.value})}
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1 text-gray-700">Horário de Término</label>
          <input
            type="time"
            className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            value={eventoData.horarioTermino}
            onChange={(e) => setEventoData({...eventoData, horarioTermino: e.target.value})}
          />
        </div>

        <div className="md:col-span-2">
          <label className="block text-sm font-medium mb-1 text-gray-700">Local do Evento</label>
          <input
            type="text"
            className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            value={eventoData.localEvento}
            onChange={(e) => setEventoData({...eventoData, localEvento: e.target.value})}
            placeholder="Ex: Salão de Festas Villa Bella"
          />
        </div>

        {calcularDuracao() && (
          <div className="md:col-span-2 bg-blue-50 p-4 rounded-md">
            <div className="flex items-center">
              <DynamicIcon name="clock" size={20} className="text-blue-600 mr-2" />
              <p className="text-sm font-medium text-blue-700">
                Duração do Evento: <span className="font-bold">{calcularDuracao()}</span>
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TabDetalhesEvento;